const mapView = {
  en: {
    mapViewPage: {
      cameroon: "Cameroon",
      title: "Interactive Map of Cameroon",
      statsLine: "{{regions}} Regions • {{divisions}} Divisions • 357 Councils",
      loading: "Loading...",
      searchPlaceholder: "Search councils...",
      seatsCount: "{{count}} seats",
      resultMeta: "{{division}} • {{region}} • {{count}} seats",
      presidential: "Presidential",
      parliamentary: "Parliamentary",
      regional: "Regional",
      council: "Council",
      goBack: "Go Back",
      currentLevel: "Current Level: {{level}}",
      levels: {
        regions: "Regions",
        divisions: "Divisions",
        subdivisions: "Subdivisions",
        councils: "Councils",
      },
      tenRegions: "10 REGIONS",
      divisionsHq: "{{count}} divisions • HQ: {{capital}}",
      divisionsHeading: "{{count}} DIVISIONS",
      subdivisionsHeading: "SUBDIVISIONS",
      villagesHeading: "VILLAGES",
      councilsBadge: "{{count}} councils",
      subdivisionsCount: "{{count}} subdivisions",
      moreCouncils: "+ {{count}} more councils",
      regionalCapitalOf: "Regional Capital of {{region}}",
      hqOfDivision: "HQ of {{name}} Division",
      hqOf: "HQ of {{name}}",
      population: "Population: {{value}}",
      notAvailable: "N/A",
      elevation: "Elevation: {{value}}m",
      legend: "Legend",
      regionalCapital: "Regional Capital",
      divisionHq: "Division HQ",
      subdivisionHq: "Subdivision HQ",
    },
  },
  fr: {
    mapViewPage: {
      cameroon: "Cameroun",
      title: "Carte interactive du Cameroun",
      statsLine: "{{regions}} régions • {{divisions}} départements • 357 communes",
      loading: "Chargement...",
      searchPlaceholder: "Rechercher des communes...",
      seatsCount: "{{count}} sièges",
      resultMeta: "{{division}} • {{region}} • {{count}} sièges",
      presidential: "Présidentielle",
      parliamentary: "Législative",
      regional: "Régionale",
      council: "Municipale",
      goBack: "Retour",
      currentLevel: "Niveau actuel : {{level}}",
      levels: {
        regions: "Régions",
        divisions: "Départements",
        subdivisions: "Arrondissements",
        councils: "Communes",
      },
      tenRegions: "10 RÉGIONS",
      divisionsHq: "{{count}} départements • Chef-lieu : {{capital}}",
      divisionsHeading: "{{count}} DÉPARTEMENTS",
      subdivisionsHeading: "ARRONDISSEMENTS",
      villagesHeading: "VILLAGES",
      councilsBadge: "{{count}} communes",
      subdivisionsCount: "{{count}} arrondissements",
      moreCouncils: "+ {{count}} communes supplémentaires",
      regionalCapitalOf: "Chef-lieu de la région : {{region}}",
      hqOfDivision: "Chef-lieu du département : {{name}}",
      hqOf: "Chef-lieu de {{name}}",
      population: "Population : {{value}}",
      notAvailable: "N/D",
      elevation: "Altitude : {{value}} m",
      legend: "Légende",
      regionalCapital: "Chef-lieu de région",
      divisionHq: "Chef-lieu de département",
      subdivisionHq: "Chef-lieu d'arrondissement",
    },
  },
};

export default mapView;
